import React, { Fragment } from "react";
import Curriculum from "../../components/Curriculum/Curriculum";
import AppHeader from "../../Layout/AppHeader";
import AppSidebar from "../../Layout/AppSidebar";
import "../../components/StudentGoal/StudentGoal.scss";

export default function MyCurriculum() {
  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="app-main__inner student-goal-page">
            <Curriculum />
          </div>
        </div>
      </div>
    </Fragment>
  );
}
